import { render, staticRenderFns } from "./PropertiesForm.vue?vue&type=template&id=7b921bb6"
import script from "./PropertiesForm.vue?vue&type=script&lang=js"
export * from "./PropertiesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports